import { render, staticRenderFns } from "./CollectionByIdView.vue?vue&type=template&id=2704b427"
import script from "./CollectionByIdView.vue?vue&type=script&lang=js"
export * from "./CollectionByIdView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports